<section>

    <div class="page page-dashboard">
        <div class="pageheader">
            <h2>User Details</h2>
            <div class="page-bar">


            </div>
        </div>

        <div class="pagecontent">
            <div class="row">
                <div class="col-sm-12">
                    <div class="tile tile-simple">

                        <!-- tile body -->
                        <div class="tile-body">
                            <div role="tabpanel">
                                <div class="tab-content">
                                    <table class="table table-bordered table-striped table-hover">
                                        <tbody>

                                            <tr>
                                                <td>Company</td>
                                                <td>{{ userdata?.company }}</td>
                                            </tr>
                                            <tr>
                                                <td width="20%">Email</td>
                                                <td>{{ userdata?.email }}</td>
                                            </tr>
                                            <tr>
                                                <td>Headquarters </td>
                                                <td>{{ userdata?.hqo }}</td>
                                            </tr>
                                            <tr>
                                                <td>Telephone number</td>
                                                <td>{{ userdata?.phone }}</td>
                                            </tr>
                                            <tr>
                                                <td>Name</td>
                                                <td>{{ userdata?.fname }}</td>
                                            </tr>
                                            <tr>
                                                <td>Surname</td>
                                                <td>{{ userdata?.lname }}</td>
                                            </tr>
                                            <tr>
                                                <td>Password</td>
                                                <td>{{ userdata?.password }}</td>
                                            </tr>
                                            <tr>
                                                <td>Expiry Date</td>
                                                <td>{{ userdata?.exp_date }}</td>
                                            </tr>
                                            <tr>
                                                <td>Change Language</td>
                                                <td>{{ userdata?.language }}</td>
                                            </tr>
                                            <tr>
                                                <td>Business Contact</td>
                                                <td>{{ userdata?.busi_contact }}</td>
                                            </tr>
                                            <tr>
                                                <td>Commission</td>
                                                <td>{{ userdata?.commission }}</td>
                                            </tr>
                                            <tr>
                                                <td>Package</td>
                                                <td><a [routerLink]="['/super/'+AppFrontRoutes.ADMIN_PACKAGE_LIST+'/'+userdata?.package_id]">{{userdata?.package_name}}</a></td>
                                            </tr>                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>

</section>